import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getHelpDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  pageContent: [
    {
      fieldName: "Card Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Card Name (EN)",
      placeholder: "Enter Card Name (EN)",
      validation: { required: "Card Name (EN) is required" },
    },
    {
      fieldName: "Card Name (MS)",
      fieldValue: "help_section_name_malay",
      className: "col-span-6",
      type: "text",
      name: "help_section_name_malay",
      formType: "input",
      label: "Card Name (MS)",
      placeholder: "Enter Card Name (MS)",
      // validation: { required: "Card Name is required" },
    },
    {
      fieldName: "Card Name (ZH)",
      fieldValue: "help_section_name_mandarin",
      className: "col-span-6",
      type: "text",
      name: "help_section_name_mandarin",
      formType: "input",
      label: "Card Name (ZH)",
      placeholder: "Enter Card Name (ZH)",
      // validation: { required: "Card Name is required" },
    },
    {
      fieldName: "Section",
      fieldValue: "section_english",
      className: "col-span-6",
      type: "select",
      name: "section_english",
      formType: "select",
      label: "Section",
      placeholder: "Select Section",
      options: [
        { label: "Services", value: "Services" },
        { label: "Support", value: "Support" },
        { label: "Feedback", value: "Feedback" },
      ],
      validation: { required: "Section is required" },
    },
    {
      fieldName: "Sequence",
      fieldValue: "sequence",
      className: "col-span-6",
      type: "text",
      name: "sequence",
      formType: "number",
      label: "Sequence",
      placeholder: "Enter Sequence",
      validation: { required: "Sequence is required" },
    },
    {
      fieldName: "Redirect Url",
      fieldValue: "help_redirect_link_english",
      className: "col-span-6",
      type: "text",
      name: "help_redirect_link_english",
      formType: "input",
      label: "Redirect Url",
      placeholder: "Enter Redirect Url",
      validation: { required: "Redirect Url is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    },
  ],
  pageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "banner_img",
      className: "col-span-6",
      type: "image",
      name: "banner_img",
      formType: "file",
      usedFileType: "image/*",
      label: "Banner Image",
      placeholder: "Enter Banner Image",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Help Text (EN)",
      fieldValue: "help_txt",
      className: "col-span-6",
      type: "text",
      name: "help_txt",
      formType: "input",
      label: "Help Text (EN)",
      placeholder: "Enter Help Text (EN)",
      validation: { required: "Help Text (EN) is required" },
    },
    {
      fieldName: "Help Text (MS)",
      fieldValue: "field_help_name_ms",
      className: "col-span-6",
      type: "text",
      name: "field_help_name_ms",
      formType: "input",
      label: "Help Text (MS)",
      placeholder: "Enter Help Text (MS)",
    },
    {
      fieldName: "Help Text (ZH)",
      fieldValue: "field_help_name_zh",
      className: "col-span-6",
      type: "text",
      name: "field_help_name_zh",
      formType: "input",
      label: "Help Text (ZH)",
      placeholder: "Enter Help Text (ZH)",
    },

    // SERVICES
    // {
    //   fieldName: "Service Text (EN)",
    //   fieldValue: "field_services_txt_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_services_txt_en",
    //   formType: "input",
    //   label: "Service Text (EN)",
    //   placeholder: "Enter Service Text (EN)",
    //   validation: { required: "Service Text (EN) is required" },
    // },
    // {
    //   fieldName: "Service Text (MS)",
    //   fieldValue: "field_services_txt_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_services_txt_ms",
    //   formType: "input",
    //   label: "Service Text (MS)",
    //   placeholder: "Enter Service Text (MS)",
    // },
    // {
    //   fieldName: "Service Text (ZH)",
    //   fieldValue: "field_services_txt_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_services_txt_zh",
    //   formType: "input",
    //   label: "Service Text (ZH)",
    //   placeholder: "Enter Service Text (ZH)",
    // },
    // {
    //   fieldName: "Service URL (EN)",
    //   fieldValue: "field_place_txt_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_place_txt_en",
    //   formType: "input",
    //   label: "Service URL (EN)",
    //   placeholder: "Enter Service URL (EN)",
    // },

    // SUPPORT
    // {
    //   fieldName: "Support Text (EN)",
    //   fieldValue: "field_support_txt_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_support_txt_en",
    //   formType: "input",
    //   label: "Support Text (EN)",
    //   placeholder: "Enter Support Text (EN)",
    //   validation: { required: "Support Text (EN) is required" },
    // },
    // {
    //   fieldName: "Support Text (MS)",
    //   fieldValue: "field_support_txt_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_support_txt_ms",
    //   formType: "input",
    //   label: "Support Text (MS)",
    //   placeholder: "Enter Support Text (MS)",
    // },
    // {
    //   fieldName: "Support Text (ZH)",
    //   fieldValue: "field_support_txt_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_support_txt_zh",
    //   formType: "input",
    //   label: "Support Text (ZH)",
    //   placeholder: "Enter Support Text (ZH)",
    // },
    // {
    //   fieldName: "Support URL (EN)",
    //   fieldValue: "field_card_redirect_url_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_card_redirect_url_en",
    //   formType: "input",
    //   label: "Support URL (EN)",
    //   placeholder: "Enter Support URL (EN)",
    // },

    // FEEDBACK
    // {
    //   fieldName: "Feedback Text (EN)",
    //   fieldValue: "field_card_name_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_card_name_en",
    //   formType: "input",
    //   label: "Feedback Text (EN)",
    //   placeholder: "Enter Feedback Text (EN)",
    //   validation: { required: "Feedback Text (EN) is required" },
    // },
    // {
    //   fieldName: "Feedback Text (MS)",
    //   fieldValue: "field_card_name_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_card_name_ms",
    //   formType: "input",
    //   label: "Feedback Text (MS)",
    //   placeholder: "Enter Feedback Text (MS)",
    // },
    // {
    //   fieldName: "Feedback Text (ZH)",
    //   fieldValue: "field_card_name_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_card_name_zh",
    //   formType: "input",
    //   label: "Feedback Text (ZH)",
    //   placeholder: "Enter Feedback Text (ZH)",
    // },
    // {
    //   fieldName: "Feedback URL (EN)",
    //   fieldValue: "field_card_redirect_url_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_card_redirect_url_en",
    //   formType: "input",
    //   label: "Feedback URL (EN)",
    //   placeholder: "Enter Feedback URL (EN)",
    // },
  ],
};
